var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Table',{attrs:{"loading":_vm.loading,"objectName":"attendees","data":_vm.attendees,"tableHeader":_vm.headers,"refresh":_vm.getAttendees}})}
var staticRenderFns = []

export { render, staticRenderFns }